import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../messages';

const GenerateReportButton = ({ disabled, showToolTip, intl }) => {
  const button = (
    <Button variant={'shout'} disabled={disabled} intl={intl}>
      <FormattedMessage {...messages.generateReport} />
    </Button>
  );
  return (
    <>
      {showToolTip ? (
        <Tooltip
          id={'generatePicReportTooltip'}
          title={<FormattedMessage {...messages.mustSelectOneRow} />}
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </>
  );
};

export default GenerateReportButton;
